import type { Aluno } from '@/domain/model/Aluno';
import type { AlunoStatusHistorico } from '@/domain/model/AlunoStatusHistorico';
import type {
  AlterarStatusAlunoUseCase, ListAlunoStatusHistoricoUseCase,
} from '@/application/port/in/AlunoStatusUseCase';
import type {
  AlterarStatusCommand, AlunoStatusGateway,
} from '@/application/port/out/AlunoStatusGateway';

export class AlterarStatusAlunoUseCaseImpl implements AlterarStatusAlunoUseCase {
  constructor(private readonly gw: AlunoStatusGateway) {}
  execute(c: AlterarStatusCommand): Promise<Aluno> { return this.gw.alterar(c); }
}
export class ListAlunoStatusHistoricoUseCaseImpl implements ListAlunoStatusHistoricoUseCase {
  constructor(private readonly gw: AlunoStatusGateway) {}
  execute(alunoId: string): Promise<AlunoStatusHistorico[]> {
    return this.gw.listHistorico(alunoId);
  }
}
